import { useFormContext } from 'react-hook-form';
import { TxCustomerInput } from '@features/components/CaseFormBlocks/components';
import { CaseFormType } from '@features/forms/CaseForms/schema';
import { TxCustomer } from '@/api/apis/customer';

type Props = {
  contactsList: TxCustomer[];
  currentSurgeon: TxCustomer | undefined;
  disabled: boolean;
  hasPermission?: boolean;
};

export const CaseSurgeonInput = ({ contactsList, hasPermission = true, currentSurgeon, disabled }: Props) => {
  const { setValue } = useFormContext<CaseFormType>();

  const onSelectSurgeon = (surgeon: TxCustomer | null) => {
    const newId = surgeon?.id ?? null;
    setValue('receivingSurgeonId', newId ?? '');
  };

  const onClear = () => {
    setValue('receivingSurgeonId', '', { shouldValidate: true });
  };

  return (
    <TxCustomerInput
      contactsList={contactsList}
      disabled={!hasPermission || disabled}
      contactFieldName="receivingSurgeonId"
      contactFieldPlaceholder="TX Center Surgeon"
      defaultValue={currentSurgeon}
      isClearable
      onClear={onClear}
      onSelect={onSelectSurgeon}
    />
  );
};
